export default "__VITE_ASSET__i3voJPNO__"